import { Button } from '@repo/ui/components';
import { FilterXIcon } from '@repo/ui/icons';
import { cn } from '@repo/ui/lib/utils';
import { memo } from 'react';
import { type Locale, t } from '../lib/i18n';
interface FilterActionsProps {
  hasFilters: boolean;
  locale?: Locale;
  onClear: () => void;
}
export const FilterActions = memo(__FilterActions);
function __FilterActions({
  hasFilters,
  locale = 'en',
  onClear
}: FilterActionsProps) {
  return <Button className={cn(!hasFilters && 'hidden', 'text-destructive hover:text-destructive')} onClick={onClear} size="sm" variant="ghost" data-sentry-element="Button" data-sentry-component="__FilterActions" data-sentry-source-file="filter-actions.tsx">
      <FilterXIcon data-sentry-element="FilterXIcon" data-sentry-source-file="filter-actions.tsx" />
      <span className="hidden md:block">{t('clear', locale)}</span>
    </Button>;
}